var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconFriends = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-407.31 -401.417)" },
                React.createElement("g", { transform: "translate(407.31 400.375)" },
                    React.createElement("path", { d: "M20.4,26.4v-2.2c0-2.4-1.9-4.3-4.3-4.3H7.4c-2.4,0-4.3,1.9-4.3,4.3v2.2" }),
                    React.createElement("path", { d: "M26.9,26.4v-2.2c0-2-1.3-3.7-3.3-4.2" }),
                    React.createElement("g", { transform: "translate(-375.31 -401.375)" },
                        React.createElement("path", { d: "M391.9,408.1c-1.3-1.3-3.3-1.3-4.6,0l-0.6,0.6l-0.6-0.6c-1.2-1.3-3.3-1.4-4.6-0.1\n\t\t\t\tc-1.3,1.2-1.4,3.3-0.1,4.6c0,0,0.1,0.1,0.1,0.1l0.6,0.6l4.6,4.6l4.6-4.6l0.6-0.6C393.2,411.4,393.2,409.4,391.9,408.1\n\t\t\t\tL391.9,408.1z" })),
                    React.createElement("path", { d: "M20.9,15.8c0,0,3.2-3.2,3.6-3.6c0.7-0.6,1.1-1.5,1-2.4l-0.2-0.6L25,8.6\n\t\t\tc-0.4-0.4-0.9-0.7-1.5-0.8c-0.9-0.2-1.9,0.3-2.3,1.1" }))))));
});
export default IconFriends;
//# sourceMappingURL=IconFriends.js.map